import styled, { keyframes } from "styled-components";
import { viewSizeCalculator } from "../../utils";

const slideUp = keyframes`
  from { opacity: 0; transform: translate(0, ${viewSizeCalculator(20, true)}); }
  to { opacity: 1; transform: translate(0, 0); }
`;

const slideDown = keyframes`
  from { opacity: 1; transform: translate(0, 0); }
  to { opacity: 0; transform: translate(0, ${viewSizeCalculator(20, true)}); }
`;

export const SnackbarWrapper = styled.div`
  position: relative;
  bottom: ${viewSizeCalculator(24, true)};
  left: 0;
  right: 0;
  margin: 0 auto;
  background: ${({ $bg }) => $bg};
  color: #fff;
  padding: ${viewSizeCalculator(14, true)}
    ${viewSizeCalculator(20, true)};
  border-radius: ${viewSizeCalculator(160, true)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${viewSizeCalculator(540, true)};
  min-width: ${viewSizeCalculator(540, true)};
  height: ${viewSizeCalculator(48, true)};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  animation: ${({ $visible }) =>
      $visible ? slideUp : slideDown}
    0.4s ease-in-out forwards;
  z-index: 5000;
  box-sizing: border-box;
  gap: ${viewSizeCalculator(12, true)};
`;

export const Message = styled.span`
  font-size: ${viewSizeCalculator(15, true)};
  font-weight: 500;
  color: ${({ $color }) => ($color ? $color : "#fff")};
  // line-height: 1;
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin-left: ${viewSizeCalculator(8, true)};
  text-transform: capitalize;
  font-size: ${viewSizeCalculator(15, true)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const SnackStackContainer = styled.div`
  position: fixed;
  bottom: ${viewSizeCalculator(24, true)};
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${viewSizeCalculator(8, true)};
  width: 100%;
  pointer-events: none;
  z-index: 5000;
`;